export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}

export enum ExpressPaymentMethods {
    gpay = 'gpay',
    paypal = 'paypal',
}

export enum StatsigSynchronousInitializationExperimentVariant {
    unknown = 'unknown',
    control = 'control',
    test = 'test',
}

export enum InitialExperimentPostPaymentQuestionsVariant {
    oldDesign = 'oldDesign',
    newDesignOneButton = 'newDesignOneButton',
    newDesignTwoButtons = 'newDesignTwoButtons',
}
